import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { CcRequirementPriority } from "server/models"
import { StateType, deepCopy, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    CcRequirementPriorityList,

    LoadCcRequirementPriorities,
    DeleteCcRequirementPriority,
    DragnDropCcRequirementPriority,

    setCcRequirementPriorityList,
    setCcRequirementPriorityIds,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Button,
    Table,
    DeleteRow,
    DragnDrop,
} from "client/components"

import Columns from "./columns"
import Edit from "./edit"

const Priority = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const priorityList = useSelector((state: StoreType) => state.ccRequirementPriority.priorityList)
    const priorityIds = useSelector((state: StoreType) => state.ccRequirementPriority.priorityIds)
    const reloadList = useSelector((state: StoreType) => state.ccRequirementPriority.reloadList)

    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const { defaultRequirementsPriorityAssigned } = project.id ? projectSettings.cc : accountSettings.cc

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const LoadData = () => {
        setLoadState(PENDING)
        LoadCcRequirementPriorities(userData.accountId, project.id)
        .then((res) => {
            dispatch(setCcRequirementPriorityList(res.priorityList))
            dispatch(setCcRequirementPriorityIds(res.priorityIds))
            setLoadState(IDLE)
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, project, defaultRequirementsPriorityAssigned])

    const onDelete: DeleteRow = (priority: CcRequirementPriority, callback) => {
        DeleteCcRequirementPriority(priority.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const priorityListCopy: CcRequirementPriorityList = priorityList ? deepCopy(priorityList) : {}
                delete priorityListCopy[priority.id]
                dispatch(setCcRequirementPriorityList(priorityListCopy))
                dispatch(setCcRequirementPriorityIds(priorityIds.filter((id) => id !== priority.id)))
            })
        })
    }

    const onDragnDrop: DragnDrop = (dataIds, callback) => {
        dispatch(setCcRequirementPriorityIds(dataIds))
        setLoadState(PENDING)
        DragnDropCcRequirementPriority(dataIds, priorityList).then((success) => {
            LoadData()
            callback(success)
        })
    }

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    const columns = Columns(editAccess)
    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                columns={columns}
                dataList={priorityList}
                dataIds={priorityIds}
                rowSize="sm"
                showPagination={false}
                onDelete={onDelete}
                onDragnDrop={onDragnDrop}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addPriority",
                            content: <Edit priorityId={0} editAccess={editAccess} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default Priority
